import React from 'react';
import { useQuery } from '@apollo/client';
import { Flex, Tag } from '@zillow/constellation';

import useQueryVariables from '../../../hooks/useQueryVariables';
import { getIsAcceptedOrInvitedToMoveIn, INVITE_TO_MOVE_IN_QUERY } from '../../../utils/inviteToMoveIn';

function ApplicationSummaryBadge() {
  const variables = useQueryVariables();
  const { data, loading, error } = useQuery(INVITE_TO_MOVE_IN_QUERY, { variables });
  const isAcceptedOrInvitedToMoveIn = getIsAcceptedOrInvitedToMoveIn(data);

  const badgeStatusText = isAcceptedOrInvitedToMoveIn ? 'Approved' : '';

  return (
    !loading &&
    !error &&
    badgeStatusText && (
      <Flex
        display="flex"
        justifyContent="space-between"
        alignItems={{ default: 'flex-start', md: 'start' }}
        flexDirection={{ default: 'column', md: 'row' }}
        marginBottom="md"
        id="application-summary-badge"
      >
        <Tag appearance="success">{badgeStatusText}</Tag>
      </Flex>
    )
  );
}

export default ApplicationSummaryBadge;
